export default function PHP_REQUEST() {
  return (
    <div>
      <h1>PHP_REQUEST</h1>
    </div>
  );
}
